import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-[var(--color-paper)] py-2 shadow-sm' : 'bg-transparent py-4'}`} data-id="element-72">
      <div className="container mx-auto flex justify-between items-center px-6" data-id="element-73">
        <Link to="/" className="flex items-center" data-id="element-74">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/o7xP4RcYHuw3uAZ62nCtvb/Ayiras_Logo.jpg" alt="Ayira's Cafe Logo" className="h-14 w-auto" data-id="element-75" />
        </Link>
        {/* Desktop Navigation */}
        <div className="hidden md:flex space-x-8" data-id="element-76">
          <NavLink to="/" scrolled={scrolled} data-id="element-77">
            Home
          </NavLink>
          <NavLink to="/about" scrolled={scrolled} data-id="element-78">
            Our Story
          </NavLink>
          <NavLink to="/founder" scrolled={scrolled} data-id="element-79">
            Founder
          </NavLink>
          <NavLink to="/programs" scrolled={scrolled} data-id="element-80">
            Programs
          </NavLink>
          <NavLink to="/future-hub" scrolled={scrolled} data-id="element-81">
            Future Hub
          </NavLink>
          <NavLink to="/media" scrolled={scrolled} data-id="element-82">
            Media
          </NavLink>
          <NavLink to="/menu" scrolled={scrolled} data-id="element-83">
            Menu
          </NavLink>
          <NavLink to="/visit" scrolled={scrolled} data-id="element-84">
            Visit Us
          </NavLink>
          <ReservationButton scrolled={scrolled} data-id="element-85" />
        </div>
        {/* Mobile menu button */}
        <button className={`md:hidden focus:outline-none transition-colors duration-300 ${scrolled ? 'text-[var(--color-ink)]' : 'text-white'}`} onClick={toggleMenu} aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-86">
          {isMenuOpen ? <XIcon size={24} data-id="element-87" /> : <MenuIcon size={24} data-id="element-88" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-[var(--color-paper)] py-6 px-6 flex flex-col space-y-4 shadow-md transition-all duration-300" data-id="element-89">
          <MobileNavLink to="/" onClick={toggleMenu} data-id="element-90">
            Home
          </MobileNavLink>
          <MobileNavLink to="/about" onClick={toggleMenu} data-id="element-91">
            Our Story
          </MobileNavLink>
          <MobileNavLink to="/founder" onClick={toggleMenu} data-id="element-92">
            Founder
          </MobileNavLink>
          <MobileNavLink to="/programs" onClick={toggleMenu} data-id="element-93">
            Programs
          </MobileNavLink>
          <MobileNavLink to="/future-hub" onClick={toggleMenu} data-id="element-94">
            Future Hub
          </MobileNavLink>
          <MobileNavLink to="/media" onClick={toggleMenu} data-id="element-95">
            Media
          </MobileNavLink>
          <MobileNavLink to="/menu" onClick={toggleMenu} data-id="element-96">
            Menu
          </MobileNavLink>
          <MobileNavLink to="/visit" onClick={toggleMenu} data-id="element-97">
            Visit Us
          </MobileNavLink>
          <ReservationButton isMobile={true} data-id="element-98" />
        </div>}
    </nav>;
};
const NavLink = ({
  to,
  children,
  scrolled
}) => <Link to={to} className={`jp-nav-link ${scrolled ? 'text-[var(--color-ink)]' : 'text-white'}`} data-id="element-99">
    {children}
  </Link>;
const MobileNavLink = ({
  to,
  children,
  onClick
}) => <Link to={to} className="jp-nav-link text-[var(--color-ink)] text-lg py-2" onClick={onClick} data-id="element-100">
    {children}
  </Link>;
const ReservationButton = ({
  isMobile = false,
  scrolled = true
}) => <a href="tel:+254746210909" className={`${isMobile ? 'w-full text-center' : ''} btn-ikigai accent-1 ${!scrolled && !isMobile ? 'border-white text-white hover:bg-white hover:text-[var(--color-ink)]' : ''}`} data-id="element-101">
    Reserve
  </a>;
export default Navbar;